module.exports = __webpack_public_path__ + "static/arkos-6ee1d90ef22dd4342b27eb6b1a4b2b4d.svg";